import { render, staticRenderFns } from "./SendDetails.vue?vue&type=template&id=643f57d7"
import script from "./SendDetails.vue?vue&type=script&lang=js"
export * from "./SendDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/workspace/Control-Panel/Control-Panel-Preprod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('643f57d7')) {
      api.createRecord('643f57d7', component.options)
    } else {
      api.reload('643f57d7', component.options)
    }
    module.hot.accept("./SendDetails.vue?vue&type=template&id=643f57d7", function () {
      api.rerender('643f57d7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Utility/SendDetails.vue"
export default component.exports